export function joinStrings(
  strings: (string | undefined | number | null)[] | undefined,
  joiner: string = ', ',
) {
  if (!strings) {
    return ''
  }
  return strings.filter(Boolean).join(joiner)
}
